import { render } from "./StoreServices.vue?vue&type=template&id=da7f3d72&scoped=true&bindings={\"items\":\"data\"}"
import script from "./StoreServices.vue?vue&type=script&lang=js"
export * from "./StoreServices.vue?vue&type=script&lang=js"

import "./StoreServices.vue?vue&type=style&index=0&id=da7f3d72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da7f3d72"

export default script